import "./LegalLinks.scss";

type LegalLink = {
  label: string;
  href: string;
};

const LEGAL_LINKS: ReadonlyArray<LegalLink> = [
  {
    label: "Terms of Service",
    href: "https://help.redgifs.com/hc/en-us/articles/39353208672785-RedGIFS-Terms-of-Service",
  },
  { label: "DMCA", href: "https://help.redgifs.com/hc/en-us/articles/39354884961041-DMCA-Policy" },
  {
    label: "Trust & Safety",
    href: "https://help.redgifs.com/hc/en-us/sections/39207968521617-Trust-and-Safety",
  },
  { label: "2257", href: "https://help.redgifs.com/hc/en-us/articles/39354987548689-18-U-S-C-2257-2257A-Record-Keeping-Compliance-Statement" },
  {
    label: "Privacy & Policy",
    href: "https://help.redgifs.com/hc/en-us/articles/39354442324753-RedGIFs-Privacy-Policy",
  },
  {
    label: "Take it Down Act",
    href: "https://help.redgifs.com/hc/en-us/articles/39355007174289-U-S-TAKE-IT-DOWN-Act-Compliance-Policy",
  },
  {
    label: "Recommender Guidelines",
    href: "https://help.redgifs.com/hc/en-us/articles/39355219651473-Recommender-System-Guidelines",
  },
];

export const LegalLinks = () => (
  <nav className="legalLinks" aria-label="Legal resources">
    <ul>
      {LEGAL_LINKS.map(({ label, href }) => (
        <li key={href}>
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer external"
            className="legalLink"
          >
            {label}
          </a>
        </li>
      ))}
    </ul>
  </nav>
);
